import { persist } from 'zustand/middleware';

import { createStore } from '@store/createStore';

const initialState = {
  sensorLocationId: undefined,
  sensorWithAi: false,
  sensorAiType: { value: 'all', label: 'All' },
  sensorAiUrgency: { value: 'all', label: 'All' },
  sensorSearch: '',
};

const useSensorStore = createStore(
  persist(
    (set) => ({
      ...initialState,

      actions: {
        setSensorLocationId: (sensorLocationId) => set({ sensorLocationId }),
        setSensorWithAi: (sensorWithAi) => set({ sensorWithAi }),
        setSensorAiType: (sensorAiType) =>
          set(() => {
            if (sensorAiType.value !== 'all') {
              return { sensorAiType, sensorWithAi: true };
            }

            return { sensorAiType };
          }),
        setSensorAiUrgency: (sensorAiUrgency) =>
          set(() => {
            if (sensorAiUrgency.value !== 'all') {
              return { sensorAiUrgency, sensorWithAi: true };
            }

            return { sensorAiUrgency };
          }),
        setSensorSearch: (sensorSearchValue) => set({ sensorSearch: sensorSearchValue, sensorLocations: {} }),
        setSensorLocations: (sensorLocations) => set({ sensorLocations }),
        setSensorFilterReset: () =>
          set({
            sensorWithAi: false,
            sensorAiType: { value: 'all', label: 'All' },
            sensorAiUrgency: { value: 'all', label: 'All' },
          }),
        setSensorAllFilterReset: () => set({ ...initialState }),
      },
    }),
    {
      version: 1.1,
      name: 'sensor-filters',
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) => key !== 'actions' && key !== 'sensorSearch'),
        ),
    },
  ),
  'sensorStore',
);

export const useSensorStoreActions = () => useSensorStore((state) => state.actions);
export const selectSensorLocationId = () => useSensorStore((state) => state.sensorLocationId);
export const selectSensorWithAi = () => useSensorStore((state) => state.sensorWithAi);
export const selectSensorAiType = () => useSensorStore((state) => state.sensorAiType);
export const selectSensorAiUrgency = () => useSensorStore((state) => state.sensorAiUrgency);
export const selectSensorSearch = () => useSensorStore((state) => state.sensorSearch);
